function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-token");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "adm1",
  transform: "translate(-31.000000, -335.000000)",
  fill: "#fff",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38,216.75 C39.9329966,216.75 41.5,218.317003 41.5,220.25 C41.5,220.733249 41.8917508,221.125 42.375,221.125 C42.8582492,221.125 43.25,220.733249 43.25,220.25 C43.25,217.350505 40.8994949,215 38,215 C35.1005051,215 32.75,217.350505 32.75,220.25 L32.75,223.0325 C31.7037374,223.402405 31.0031188,224.390277 31,225.5 L31,230.75 C31,232.199747 32.1752525,233.375 33.625,233.375 L42.375,233.375 C43.8247475,233.375 45,232.199747 45,230.75 L45,225.5 C45,224.050253 43.8247475,222.875 42.375,222.875 L34.5,222.875 L34.5,220.25 C34.5,218.317003 36.0670034,216.75 38,216.75 Z M42.375,224.625 C42.8582492,224.625 43.25,225.016751 43.25,225.5 L43.25,230.75 C43.25,231.233249 42.8582492,231.625 42.375,231.625 L33.625,231.625 C33.1417508,231.625 32.75,231.233249 32.75,230.75 L32.75,225.5 C32.75,225.016751 33.1417508,224.625 33.625,224.625 L42.375,224.625 Z",
  id: "icon-token"
}))));

var SvgToken = function SvgToken(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToken, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/token.a4c982bc.svg";
export { ForwardRef as ReactComponent };